<template>
  <div id="app" >
    <!--  <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
import { } from '@/api/association'
export default {
  name: 'App',
  data () {
    return {
    }
  },
  created () {

  },
  beforeCreate () {
    // var host = window.location.host
    // var protocol = window.location.protocol
    // console.log(host, protocol)
    // // if (host) {
    // //   this.$router.push({
    // //     name: 'IndexAsso'
    // //   })
    // // }
    // findAssoIdByDomainName({ domainName: protocol + '//' + host }).then(res => {
    //   // debugger
    //   if (res.data.status === 0) {
    //     if (res.data.data == null) {
    //       this.$message.error('协会信息获取失败')
    //     } else {
    //       localStorage.setItem('assoId', res.data.data.id)
    //       localStorage.setItem('assoInfo', JSON.stringify(res.data.data))
    //       this.isShow = true
    //     }
    //   }
    // })
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue